import { authRoles } from "app/main/consts";
import i18next from "i18next";
import en from "./i18n/en";
import es from "./i18n/es";

import LoadSearchRequest from "./LoadSearchRequest";

i18next.addResourceBundle("en", "LoadSearchRequestPage", en);
i18next.addResourceBundle("es", "LoadSearchRequestPage", es);

const LoadSearchRequestConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false,
				},
				header: {
					display: false,
				},
			},
		},
	},
	auth: [...authRoles.all, ...authRoles.bot, ...authRoles.deactivated],
	routes: [
		{
			path: "/load",
			component: LoadSearchRequest,
		},
	],
};

export default LoadSearchRequestConfig;
